import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    selectUserClearance,
    selectViewMode,
    setViewMode
} from '../../features/auth/authSlice';

const DashboardToggle = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const currentMode = useSelector(selectViewMode);
    const clearanceValue = useSelector(selectUserClearance);
    const currentUser = useSelector((state: any) => state.auth.user);
    
    const adminRoles = ['super_admin', 'admin', 'hr_admin', 'hr', 'manager'];
    const userRole = (currentUser?.role || '').toLowerCase();
    const isAdminAccount = adminRoles.includes(userRole);

    // Hide the toggle entirely if the user doesn't have HR/Admin access
    if (!isAdminAccount) return null;

    const handleToggle = (targetMode: 'ESS' | 'ADMIN') => {
        if (currentMode !== targetMode) {
            dispatch(setViewMode(targetMode));
            if (targetMode === 'ADMIN') {
                // Land directly on the HR Management Dashboard
                navigate('/dashboard');
            } else {
                // Land on Personal ESS Dashboard
                navigate('/ess/dashboard');
            }
        }
    };

    return (
        <div className="flex items-center bg-gray-100/80 backdrop-blur-sm p-1 rounded-2xl border border-gray-200 shadow-sm transition-all duration-300 hover:shadow-md">
            <button
                onClick={() => handleToggle('ESS')}
                className={`
                    flex items-center space-x-2 rtl:space-x-reverse px-4 py-2 rounded-xl text-xs font-bold transition-all duration-300
                    ${currentMode === 'ESS' 
                        ? 'bg-white text-blue-600 shadow-sm' 
                        : 'text-gray-500 hover:text-gray-700'}
                `}
            >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <span>{t('common.myEss')}</span>
            </button>
            <button
                onClick={() => handleToggle('ADMIN')}
                className={`
                    flex items-center space-x-2 rtl:space-x-reverse px-4 py-2 rounded-xl text-xs font-bold transition-all duration-300
                    ${currentMode === 'ADMIN' 
                        ? 'bg-white text-blue-600 shadow-sm' 
                        : 'text-gray-500 hover:text-gray-700'}
                `}
            >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1" />
                </svg>
                <span>{t('common.hrDashboard')}</span>
            </button>
        </div>
    );
};

export default DashboardToggle;
